import { makeVar, useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';
import { initRemoteConfig, getRemoteConfigBoolean } from '../firebase';

export interface RemoteConfigValues {
  googleAdsEnabled: boolean;
  googleAdTest: boolean;
  isLoading: boolean;
}

const remoteConfigVar = makeVar<RemoteConfigValues>({
  googleAdsEnabled: false,
  googleAdTest: false,
  isLoading: true,
});

// Reset to false on failure so the next mount retries.
let initTriggered = false;

const loadRemoteConfig = async () => {
  if (initTriggered) return;
  initTriggered = true;
  try {
    const result = await initRemoteConfig();
    if (result === null) {
      console.error('useRemoteConfig: Remote Config init failed; using defaults. Retry on next mount.');
      initTriggered = false;
    }
    remoteConfigVar({
      googleAdsEnabled: getRemoteConfigBoolean('google_ads_enabled'),
      googleAdTest: getRemoteConfigBoolean('google_adtest'),
      isLoading: false,
    });
  } catch (err) {
    console.error('useRemoteConfig: unexpected error during Remote Config init; using defaults', err);
    initTriggered = false;
    remoteConfigVar({ ...remoteConfigVar(), isLoading: false });
  }
};

// hook — all consumers share one remoteConfigVar update rather than triggering separate re-renders.
export const useRemoteConfig = (): RemoteConfigValues => {
  useEffect(() => { void loadRemoteConfig(); }, []);
  return useReactiveVar(remoteConfigVar);
};
